import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {SASEUNG3_BOOKMARK_API_URL} from '../../defines/protocol';
import {ApiService} from '../api/api.service';
import {TotalService} from '../total/total.service';
import {Saseung3HanjaService} from './saseung3-hanja.service';


@Injectable({
  providedIn: 'root'
})
export class Saseung3BookmarkService extends Saseung3HanjaService {

  constructor(
    api: ApiService,
    private totalSvc: TotalService,
  ) {
    super(api);
    this.urlApi = SASEUNG3_BOOKMARK_API_URL;
  }

  public sendBookmark(id: string, add: boolean = true): Observable<boolean> {
    const url = this.urlApi + id + '/';
    const obs = add ? this.api.Post(url, null) : this.api.Delete(url);

    return obs.pipe(
      map(data => {
        console.log('Saseung3BookmarkService::sendBookmark()', id, add, data);
        this.totalSvc.updateSaseungBookmarkCount(add);
        return data;
      }),
    );
  }

  public hideBookmark(id: string): void {
    if (this.totalCount === null || this.listSaseung === null) {
      console.error('Saseung3BookmarkService::hideBookmark() list not loaded', {totalCount: this.totalCount, listSaseung: this.listSaseung});
      return;
    }

    const idx = this.listSaseung.findIndex(saseung => saseung.id === id);
    if (idx !== -1) {
      this.listSaseung.splice(idx, 1);
      --this.totalCount;
    }
    else {
      console.warn(`Saseung3BookmarkService::hideBookmark(${id}) saseung does not exist`);
    }
  }
}
